<template>
  <div>

    <p v-if="!hasInfo">
      Can not show info about products.<br>
      <br>
      Billing table {{billingRecord.TableId}}<br>
      does not contain billing item<br>
      {{billingRecord.Service}}.<br>
      <br>
      Maybe billing item was deleted from billing table<br>
      or renamed.
    </p>

    <p v-if="message !== null">
      {{message}}
    </p>

    <table
      v-if="productGroups !== null && productGroups.length > 0"
      class="product-groups-table"
    >
      <tr>
        <th>Product</th>
        <th class="text-right">Amount</th>
      </tr>
      <tr
        v-for="productGroup in productGroups"
        :key="productGroup.proto_id"
      >
        <td>{{productGroup.proto_id | getProtoAlias}}</td>
        <td class="text-right">{{productGroup.amount | getFormattedNumber}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'BillingProductsTable',

  props: {
    billingRecord: {
      type: Object,
      required: true,
    },

    productGroups: {
      //type: Array or null,
      required: true,
    },
  },

  computed: {
    hasInfo() {
      return this.productGroups !== null;
    },

    message() {
      if(this.productGroups !== null && this.productGroups.length === 0) {
        return 'No products';
      }
      return null;
    },
  },
};
</script>

<style scoped>
  .product-groups-table {
    white-space: nowrap;
  }

  .product-groups-table td:first-child {
    padding-right: 0.5rem;
  }
</style>
